import {gql} from 'graphql-request';
import {saasFragment} from 'src/services/shared/Fragments';
import {doAuthenticatedQuery} from "src/services/shared/doQuery";
import {driftFragment} from "../DriftService/DriftQueries";
import {driftFromDefault} from "../../utils/constants";
import {IDrift} from "../../types/Drift";
import {transformDrifts} from "../DriftService/DriftTransform";
import {SaasIdentifier} from "../../types/Saas";
import {nullCollapsableClientPubId} from "./nullCollapsableUtilities";
import {QueryContext} from "../../hooks/TanstackHooks";

const getZombiesQuery = gql`
query Zombies(
    $driftFrom: timestamp,
    $clientBoolExp: client_bool_exp
) {
  drift(
      where: {
      _and:[
      {client_saas: {saas: {name: {_neq: "${SaasIdentifier.bamboohr}"}}}},
      {client_saas: {saas: {name: {_neq: "${SaasIdentifier.employmenthero}"}}}},
      {client_saas: {saas: {name: {_neq: "${SaasIdentifier.hibob}"}}}},
      {client_saas: {client: $clientBoolExp}}
      ],
    subject: {_eq: USER_ACTIVITY},
    drift_time: {_gt: $driftFrom},
    new_value: {_eq : "Active"},
    old_value: {_eq : "Inactive"},
    
    _or:[
      {suppressed_until:{_is_null: true}},
      {suppressed_until:{_lt:"now()"}}
    ],
  },
  order_by: {drift_time: desc}
) {
  ...Drift
  }
}
${driftFragment}
${saasFragment}
`;

const getZombiesCountQuery = gql`
query ZombiesCount(
    $driftFrom: timestamp,
    $clientBoolExp: client_bool_exp
) {
  drift_aggregate(
      where: {
      _and:[
      {client_saas: {saas: {name: {_neq: "${SaasIdentifier.bamboohr}"}}}},
      {client_saas: {saas: {name: {_neq: "${SaasIdentifier.employmenthero}"}}}},
      {client_saas: {saas: {name: {_neq: "${SaasIdentifier.hibob}"}}}},
      {client_saas: {client: $clientBoolExp}}
      ],
    subject: {_eq: USER_ACTIVITY},
    drift_time: {_gt: $driftFrom},
    new_value: {_eq : "Active"},
    old_value: {_eq : "Inactive"},
    
    _or:[
      {suppressed_until:{_is_null: true}},
      {suppressed_until:{_lt:"now()"}}
    ],
  }
) {
    aggregate{
      count
    }
  }
}
`;


export const getZombies = async ({accessToken, queryContext}:{
  accessToken: any,
  queryContext: QueryContext}
): Promise<IDrift> => {


  const theQuery = async (client: any) => {
    const variables = {
      driftFrom: driftFromDefault(),
      ...nullCollapsableClientPubId(queryContext.client.id)
    }

    const result = client.request(
      getZombiesQuery,
      variables,
    );
    return result;
  };

  let response;
  try {
    response = await doAuthenticatedQuery(
      theQuery, accessToken
    );
  }
  catch (error) {
    console.error('getZombies error', {error})
    throw (error)
  }

  const result = response.drift.map((drift: any) => {
    return transformDrifts(drift);
  });
  return result;
};

export const getZombiesCount = async ({accessToken, queryContext}:{
  accessToken: any,
  queryContext: QueryContext}
): Promise<IDrift> => {


  const theQuery = async (client: any) => {
    const variables = {
      driftFrom: driftFromDefault(),
      ...nullCollapsableClientPubId(queryContext.client.id)
    }

    const result = client.request(
      getZombiesCountQuery,
      variables,
    );
    return result;
  };

  let response;
  try {
    response = await doAuthenticatedQuery(
      theQuery, accessToken
    );
  }
  catch (error) {
    console.error('getZombiesCount error', {error})
    throw (error)
  }

  return response.drift_aggregate.aggregate.count;
};
